module.exports = __webpack_public_path__ + "frontend/images/logos/small/small-gold.png?6f12b3107bbecd3bfb84575cd1c951ea";